import React from "react"
import { PieAmchartSeeker } from "@ui-seeker/core"
import { Skeleton } from "@mui/material"


export default function SearchAnalyticsPieChart({ data, isDateRangeLoading }) {

	if (isDateRangeLoading) return <Skeleton variant="rectangular" height={400}/>
	
	return <PieAmchartSeeker
		rootID="SearchAnalyticsPieChart"
		data={data.percentageSite}
		title="Number of searches by Site"
		series={[{
			yField: 'site',
			xField: "percentage",
			innerRadius: 60,
		}]}
		sx={{ height: 300 }}
		chartProps={{
			enabledPDF: false,
			chart: {
				horizontalLayout: true,
			},
			root: {
				colors: data?.siteSeries?.map(({ color }) => color)
			},
			legend: {
				centerY: 47.3,
				y: 45,
				verticalLayout: true,
				labels: {
					maxWidth: 140,
					width: 140,
					oversizedBehavior: "wrap"
				},
				valueLabels: {
					textAlign: "right"
				}
			}
		}}

	/>
}